module.exports = __webpack_public_path__ + "files/08959a08dc2488dfeb8660fc4630b145.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-120x120.png
// module id = 1813
// module chunks = 59